import React, { CSSProperties, useState } from 'react';

import AssetLibrary from './AssetLibrary/AssetLibrary';
import { AssetType } from '../../shared/models/Asset';
import Button from '@mui/material/Button';
import { MediaComponent } from '../../content/models/LessonComponent';
import { cloneDeep } from 'lodash';
import styles from '../styles/ChangeFile.module.css';
import { useLessonEditContext } from '../../content/models/LessonEditContext';

interface ChangeFileProps {
  component?: MediaComponent;
  label?: string;
  assetkey: string;
  assetTypes: AssetType[];
  fileType?: string;
  style?: CSSProperties;
  noButtonPosition?: boolean /** Value indicating that when there is no need of applying styles for positioning 'Change File' button */;
  handleSelect?: (assetkey: string) => void;
}
export default function ChangeFile(props: ChangeFileProps) {
  const [showAssetLibrary, setShowAssetLibrary] = useState(false);

  const handleShowAssetLibrary = () => {
    setShowAssetLibrary(true);
  };

  const handleCloseAssetLibrary = () => {
    setShowAssetLibrary(false);
  };

  const { handleSettingsChange } = useLessonEditContext();

  const handleAssetSelect = (assetkey: string) => {
    const copy = cloneDeep(props.component);
    copy.settings.assetkey = assetkey;
    handleSettingsChange(copy);
  };

  return (
    <>
      <div
        className={props.noButtonPosition ? '' : styles.changeFilePosition}
        style={props.style || {}}
      >
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={handleShowAssetLibrary}
        >
          {props.label || 'Change File'}
        </Button>
      </div>
      {showAssetLibrary && (
        <AssetLibrary
          types={props.assetTypes}
          category="author"
          title={
            props.fileType ||
            `Select ${props.assetTypes
              .map((type) => type[0].toUpperCase() + type.slice(1))
              .join(' / ')}`
          }
          selectedAssetkey={props.assetkey}
          //For Column and Carousel Components, handleSelect should be called because assetkey will be stored in content not settings
          onSelect={props.component ? handleAssetSelect : props.handleSelect}
          onClose={handleCloseAssetLibrary}
        />
      )}
    </>
  );
}
